import { createAction, createActionGroup, emptyProps, props } from "@ngrx/store";
import { CurrencyType, ITableState, ITournamentState } from '@soposopo/sopo-models';
import { ComponentToLoad, GameSettings, GameStateId, TableMessage, CommonGameActionProps } from './game.state';

export const dealerResetAction = createAction(
    '[socket-service] Dealer Reset',
    props<{
        gameStateId: GameStateId,
    }>()
)

export const gameErrorAction = createAction(
    '[Game] Error from Firebase',
    props<{
        error: any;
        gameStateId: GameStateId;
    }>(),
)

export const leaveTableAction = createAction(
    'PLAYER LEFT TABLE',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const leaveTableCompletedAction = createAction(
    'PLAYER LEFT COMPLETED',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const joinTableAction = createAction(
    'PLAYER JOIN',
    props<{
        gameStateId: GameStateId;
    }>()
)


export const joinTableCompleteAction = createAction(
    'PLAYER JOIN COMPLETED',
    props<{
        gameStateId: GameStateId;
    }>()
)

export const tableBottomImageSet = createAction(
    'TABLE BOTTOM IMAGE SET',
    props<{
        gameStateId: GameStateId;
        imageSrc: string;
    }>()
)

export const GameDispatcherActions = createActionGroup({
    source: 'Game Dispatcher',
    events: {

        'Add new game to state': (game: ComponentToLoad, toNav: boolean, promptOwner: boolean = false) => ({
            game,
            toNav,
            promptOwner
        }),

        'Reset to nav in game': props<{
            gameStateId: GameStateId;
        }>(),

        'Game Id Loaded From Local Storage': props<{
            id: string;
        }>(),

        'Table Data Updated': props<{
            table: ITableState;
            gameStateId: GameStateId;
        }>(),

        'Tournament Data Updated': props<{
            tournament: ITournamentState;
            gameStateId: GameStateId;
        }>(),

        'Tournament Tables Data Updated': props<{
            tables: {[key: string]: ITableState};
            gameStateId: GameStateId;
        }>(),

        'Dealer Data Updated': props<CommonGameActionProps>(),

        'Hand Data Updated': props<{
            hand: any;
            playerId: string;
            gameStateId: GameStateId;
        }>(),

        'Game Loaded': props<CommonGameActionProps>(),

        'Table Message Data Updated': props<{
            messages: TableMessage[];
            gameStateId: GameStateId;
            playerId: string;
        }>(),

        'New Table Message Recieved': props<{
            message: TableMessage;
            gameStateId: GameStateId;
            playerId: string;
        }>(),

        'Reset Unread Table Messages Count': props<{
            gameStateId: GameStateId;
        }>(),

        'Blinds Posted': props<CommonGameActionProps>(),

        'Ante Posted': props<CommonGameActionProps>(),

        'Blinds and Ante Posted': props<CommonGameActionProps>(),

        'Post Dead Blinds': props<CommonGameActionProps>(),

        'Hold Em Game Started': props<CommonGameActionProps>(),

        'Short Deck Game Started': props<CommonGameActionProps>(),

        'Omaha Game Started': props<CommonGameActionProps>(),

        'Omaha5 Game Started': props<CommonGameActionProps>(),

        'Omaha Hi Lo Game Started': props<CommonGameActionProps>(),

        'Razz Game Started': props<CommonGameActionProps>(),

        'Stud Game Started': props<CommonGameActionProps>(),

        'Stud Hi Lo Game Started': props<CommonGameActionProps>(),

        'Player Added Time': props<CommonGameActionProps>(),

        'Player Betted': props<CommonGameActionProps>(),

        'Player Checked': props<CommonGameActionProps>(),

        'Player Called': props<CommonGameActionProps>(),

        'Player Folded': props<CommonGameActionProps>(),

        'Player Folded No Showdown': props<CommonGameActionProps>(),

        'Player Hunted Rabbit': props<CommonGameActionProps>(),

        'Player Raised': props<CommonGameActionProps>(),

        'Player Checked by Timeout': props<CommonGameActionProps>(),

        'Player Folded by Timeout': props<CommonGameActionProps>(),

        'Player Went All In': props<CommonGameActionProps>(),

        'Advanced To Flop': props<CommonGameActionProps>(),

        'Advanced To Turn': props<CommonGameActionProps>(),

        'Advanced To River': props<CommonGameActionProps>(),

        'Advanced To Third Street': props<CommonGameActionProps>(),

        'Advanced To Fourth Street': props<CommonGameActionProps>(),

        'Advanced To Fifth Street': props<CommonGameActionProps>(),

        'Advanced To Sixth Street': props<CommonGameActionProps>(),

        'Advanced To Seventh Street': props<CommonGameActionProps>(),

        'Advanced To Last Man Standing': props<CommonGameActionProps>(),

        'Advanced To Showdown': props<CommonGameActionProps>(),

        'Advanced To Pay Winner': props<CommonGameActionProps>(),

        'Advanced To Bad Beat Jackpot': props<CommonGameActionProps>(),

        'Advanced To Game Over': props<CommonGameActionProps>(),

        'Toggle Card': props<{
            revealCardIndex: number;
            playerId: string;
            gameStateId: GameStateId;
        }>(),

        'Remove game from games list': props<{
            gameStateId: GameStateId;
            removedGame?: ComponentToLoad;
            currency?: CurrencyType;
            invitationRejected?: boolean;
        }>(),

        'Remove all game states': () => ({ remainingGames: [] }),

        'Update Delta Game State': props<CommonGameActionProps>(),

        'Timebank Count Updated': props<{
            count: number;
        }>(),

        'Timebank Count Reset': () => ({ count: 0 }),

        'Change Selected Game': props<{
            gameStateId: GameStateId;
        }>(),

        'Set Grid View': props<{
            enabled: boolean;
        }>(),

        'Clear Games List': emptyProps(),

        'Modify Game Settings': props<{
            gameStateId: GameStateId;
            settings: GameSettings;
        }>(),

        'Close All Club Games': props<{
            clubId: string;
        }>(),

        'Change Club Id': props<{
            gameStateId: GameStateId;
            clubId: string;
        }>(),

        'Update GameToPreviewId':  props<{
            gameToPreviewId: string,
        }>()

    }
})
